import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'al2008',
    ecrans: ['00-2'],
    params: ['id',
             '?dlhcleint',
             '?dlpcleint',
             '?dlhdatvig'
    ]
});
